import { render, staticRenderFns } from "./MessageShowNew.vue?vue&type=template&id=38515e1f&"
import script from "./MessageShowNew.vue?vue&type=script&lang=js&"
export * from "./MessageShowNew.vue?vue&type=script&lang=js&"
import style0 from "./MessageShowNew.vue?vue&type=style&index=0&id=38515e1f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports